module.exports = __webpack_public_path__ + "media/batman@xl-b81791249c9e9e96cf747f50d70e8ec6.jpg";